import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../shared/shared.module';
import { AccessGrantedComponent } from './access-granted/access-granted.component';
import {
    QuickbooksContainerComponent,
    QuickbooksImportListsRoute,
    QuickbooksJournalEntryRoute,
    QuickbooksRevokeAccessRoute,
    QuickbooksRoute,
    QuickbooksRouteAccessGrantedRoute,
    QuickbooksSendHoursRoute,
    QuickbooksProcessPeriodRoute,
    QuickbooksRouteAccessRevokedRoute,
    QuickbooksConnectRoute
} from './quickbooks.route';
import * as fromStore from './store';
import { QuickbooksEffects } from './store';
import { SyncListsComponent } from './sync-lists/sync-lists.component';
import { SendHoursContainerComponent } from './send-hours/send-hours-container/send-hours-container.component';
import { SendHoursPresenterComponent } from './send-hours/send-hours-presenter/send-hours-presenter.component';
import { SendHoursFilterComponent } from './send-hours/send-hours-filter/send-hours-filter.component';
import {
    SendJournalEntryContainerComponent,
    SendJournalEntryPresenterComponent,
    SendJournalEntryFilterComponent
} from './send-journal-entry';
import { SendBillPresenterComponent } from './send-hours/send-bill-presenter/send-bill-presenter.component';
import { QuickbooksRevokeAccessComponent } from './quickbooks-revoke-access/quickbooks-revoke-access.component';
import { SendPurchasesModule } from './send-purchases/send-purchases.module';
import { SendInvoiceModule } from './send-invoice/send-invoice.module';
import { AccessRevokedComponent } from './access-revoked/access-revoked.component';
import { LoggingService } from '../shared/services/logging';
import { QuickBooksConnectComponent } from './quick-books-connect/quick-books-connect.component';
@NgModule({
    declarations: [
        QuickbooksContainerComponent,
        AccessGrantedComponent,
        SyncListsComponent,
        SendHoursContainerComponent,
        SendHoursPresenterComponent,
        SendHoursFilterComponent,
        SendJournalEntryContainerComponent,
        SendJournalEntryPresenterComponent,
        SendJournalEntryFilterComponent,
        SendBillPresenterComponent,
        QuickbooksRevokeAccessComponent,
        AccessRevokedComponent,
        QuickBooksConnectComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        SendPurchasesModule,
        SendInvoiceModule,
        UIRouterModule.forChild({
            states: [
                QuickbooksRoute,
                QuickbooksRouteAccessGrantedRoute,
                QuickbooksImportListsRoute,
                QuickbooksSendHoursRoute,
                QuickbooksJournalEntryRoute,
                QuickbooksRevokeAccessRoute,
                QuickbooksRouteAccessRevokedRoute,
                QuickbooksProcessPeriodRoute,
                QuickbooksConnectRoute
            ]
        }),
        StoreModule.forFeature(
            fromStore.quickbooksFeatureKey,
            fromStore.reducer
        ),
        EffectsModule.forFeature([QuickbooksEffects])
    ]
})
export class QuickbooksModule {
    /**
     *
     */
    constructor(private log: LoggingService) {
        this.log.verbose('QuickbooksModule: constructor');
    }
}
